import { table } from './_table';
export const products = {
  namespaced: true,
  modules: {
    table
  }
};
